export class ProjectionHelper {
    #projection = null;
    #overlay;

    constructor(map) {
        // DummyOverlay nutzen, um Zugriff auf die Kartenprojektion zu bekommen
        this.#overlay = new google.maps.OverlayView();
        this.#overlay.onAdd = () => {};
        this.#overlay.draw = () => {
            if (!this.#projection) {
                this.#projection = this.#overlay.getProjection();
                google.maps.event.trigger(this.#overlay, 'ready');
            }
        };
        this.#overlay.onRemove = () => {};
        this.#overlay.setMap(map);
    }

    getOverlay() {
        return this.#overlay;
    }

    isReady() {
        return !!this.#projection;
    }

    /**
     * LatLng → Pixel (Point)
     */
    latLngToPixel(latLng) {
        return this.#projection?.fromLatLngToDivPixel(latLng) || null;
    }

    /**
     * Pixel (Point) → LatLng
     */
    pixelToLatLng(point) {
        return this.#projection?.fromDivPixelToLatLng(point) || null;
    }

    /**
     * Container-Pixel (x, y relativ zum Karten-Container, z.B. Maus-/Drop-Position aus DOM-Events) → LatLng.
     * Im Gegensatz zu pixelToLatLng() (Div-Pixel) für Eingaben aus DOM-Koordinaten nötig.
     * @returns {google.maps.LatLng|null} null, solange die Projektion noch nicht bereit ist.
     */
    containerPixelToLatLng(x, y) {
        if (!this.#projection) { return null; }
        return this.#projection.fromContainerPixelToLatLng(new google.maps.Point(x, y));
    }

    /**
     * Verschiebt einen LatLng-Punkt um (x, y) Pixel und gibt neuen LatLng zurück
     */
    offsetLatLng(latLng, dx, dy) {
        if (!this.#projection) return null;

        const pixel = this.#projection.fromLatLngToDivPixel(latLng);
        const shifted = new google.maps.Point(pixel.x + dx, pixel.y + dy);
        return this.#projection.fromDivPixelToLatLng(shifted);
    }

    destroy() {
        this.#overlay?.setMap(null);
        this.#overlay = null;
        this.#projection = null;
    }
}
